import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getAvailableProviders } from 'config/requests/providerAccounts';
import { useRecordContext } from 'react-admin';
import { AutocompleteInput } from 'shared/react-admin/Inputs';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { convertReactAdminIdToHydraId } from 'utils/convertReactAdminIdToHydraId';

type ProviderAccountsProviderInputProps = {
  company?: string;
  merchants?: string[];
  provider?: string;
};

export const ProviderAccountsProviderInput: React.FC<ProviderAccountsProviderInputProps> = ({
  company,
  merchants,
  provider,
}) => {
  const record = useRecordContext<ProviderAccount>();
  const isDisabled = !company || !merchants?.length;

  const { data: availableProviders, isLoading } = useQuery({
    queryKey: ['providers/available/provider-account', company, merchants],
    queryFn: () => getAvailableProviders(company as string, merchants as string[]),
    enabled: !isDisabled,
  });

  const choices = (availableProviders ?? []).map(({ id, name }) => ({
    id: convertReactAdminIdToHydraId(id, Resources.Providers),
    name,
  }));

  const isRecordProviderMissing =
    !!record?.provider &&
    provider === record.provider['@id'] &&
    !choices.some(({ id }) => id === provider);

  return (
    <AutocompleteInput
      choices={
        isRecordProviderMissing
          ? [{ id: record.provider['@id'], name: record.provider.name }, ...choices]
          : choices
      }
      disabled={isDisabled}
      disabledHint="Сначала выберите компанию и мерчанта"
      fullWidth
      isPending={isLoading}
      label="Провайдер"
      optionText="name"
      source="provider"
      variant="outlined"
    />
  );
};
